{
  "title": "患者交接 (I-PASS)",
  "illnessSeverity": "病情严重程度",
  "patientSummary": "患者概要",
  "actionList": "待办事项清单",
  "situationAwareness": "情境意识",
  "synthesis": "接收方综合",
  "acknowledge": "确认接收交接",
  "severity": {
    "stable": "稳定",
    "watcher": "需观察",
    "unstable": "不稳定"
  },
  "loading": "正在加载交接…",
  "errorState": "无法加载交接。",
  "emptyState": "没有待您接收的交接。",
  "unknownPatient": "未知患者",
  "from": "由 {{name}} 交接",
  "openChart": "打开病历",
  "notProvided": "未提供",
  "noActions": "没有列出待办事项。",
  "noContingency": "未提供应急预案。请向交班医护询问需要观察的情况。",
  "synthesisHint": "请复述您的理解。这是该流程存在的意义所在。",
  "synthesisPlaceholder": "用我自己的话说，计划是…",
  "acknowledgedAt": "已于 {{when}} 确认",
  "toast": {
    "acknowledged": "交接已确认",
    "acknowledgeFailed": "无法确认交接"
  },
  "ipass": {
    "illness": "I — 病情严重程度",
    "patientSummary": "P — 患者概要",
    "actionList": "A — 待办事项",
    "situationAwareness": "S — 情况认知",
    "contingencyPlan": "S — 应急预案",
    "synthesis": "S — 接收方复述"
  }
}
